import { render, staticRenderFns } from "./ReferralChart.vue?vue&type=template&id=64d70363&"
import script from "./ReferralChart.vue?vue&type=script&lang=js&"
export * from "./ReferralChart.vue?vue&type=script&lang=js&"
import style0 from "./ReferralChart.vue?vue&type=style&index=0&id=64d70363&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports